import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function CaretLeftIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5304 5.46967C15.8233 5.76256 15.8233 6.23744 15.5304 6.53033L10.2375 11.8232C10.1674 11.8933 10.1107 11.9501 10.0623 12C10.1107 12.0499 10.1674 12.1067 10.2375 12.1768L15.5304 17.4697C15.8233 17.7626 15.8233 18.2374 15.5304 18.5303C15.2375 18.8232 14.7626 18.8232 14.4697 18.5303L9.17682 13.2374C9.16875 13.2294 9.16062 13.2212 9.15246 13.2131C9.00737 13.0681 8.85047 12.9113 8.73589 12.7612C8.60165 12.5852 8.45715 12.3335 8.45715 12C8.45715 11.6665 8.60165 11.4148 8.73589 11.2388C8.85047 11.0887 9.00737 10.9319 9.15246 10.7869C9.16062 10.7788 9.16875 10.7706 9.17682 10.7626L14.4697 5.46967C14.7626 5.17678 15.2375 5.17678 15.5304 5.46967Z"
      />
    </SvgIcon>
  );
}
